(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bcw-mobile-buy-bar"] && !Shopify.designMode) return;
  try {
    
  const ensureNativeQuantityButtons = () => {
    document
      .querySelectorAll('quantity-input .qty-btn[name="minus"], quantity-input .qty-btn[name="plus"]')
      .forEach((button) => button.classList.add('quantity__button'));
  };

  ensureNativeQuantityButtons();
  document.addEventListener('shopify:section:load', ensureNativeQuantityButtons);

  if (!customElements.get('bcw-mobile-buybar')) {
    customElements.define('bcw-mobile-buybar', class extends HTMLElement {
      connectedCallback() {
        this.mobileQuery = window.matchMedia('(max-width: 1023px)');
        this.bar = this.querySelector('[data-bcw-mobile-buybar]');
        this.quantityInput = this.querySelector('[data-bcw-quantity]');
        this.total = this.querySelector('[data-bcw-total]');
        this.submit = this.querySelector('[data-bcw-submit]');
        this.submitLabel = this.querySelector('[data-bcw-submit-label]');
        this.variants = JSON.parse(this.querySelector('[data-bcw-variants]').textContent);
        this.currentVariantId = this.dataset.initialVariantId;
        this.quantity = 1;
        this.boundCheckPosition = this.checkPosition.bind(this);
        this.boundSyncFromMain = this.syncFromMain.bind(this);
        this.boundOverlayCheck = () => window.setTimeout(this.boundCheckPosition, 0);
        this.boundMediaChange = this.boundCheckPosition;
        this.querySelector('[data-bcw-decrease]').addEventListener('click', () => this.setQuantity(this.quantity - 1));
        this.querySelector('[data-bcw-increase]').addEventListener('click', () => this.setQuantity(this.quantity + 1));
        this.submit.addEventListener('click', () => this.addToCart());
        document.addEventListener('change', this.boundSyncFromMain);
        document.addEventListener('click', this.boundSyncFromMain);
        document.addEventListener('click', this.boundOverlayCheck);
        document.addEventListener('keydown', this.boundOverlayCheck);
        document.addEventListener('bcw:overlay-change', this.boundCheckPosition);
        window.addEventListener('scroll', this.boundCheckPosition, { passive: true });
        window.addEventListener('resize', this.boundMediaChange, { passive: true });
        if (this.mobileQuery.addEventListener) {
          this.mobileQuery.addEventListener('change', this.boundMediaChange);
        } else {
          this.mobileQuery.addListener(this.boundMediaChange);
        }
        this.overlayObserver = new MutationObserver(this.boundCheckPosition);
        document
          .querySelectorAll('.country-selector, details.menu-drawer-container, dialog, cart-drawer')
          .forEach((element) => this.overlayObserver.observe(element, {
            attributes: true,
            attributeFilter: ['class', 'hidden', 'open', 'aria-hidden']
          }));
        requestAnimationFrame(() => {
          this.syncFromMain();
          this.checkPosition();
        });
      }

      disconnectedCallback() {
        document.removeEventListener('change', this.boundSyncFromMain);
        document.removeEventListener('click', this.boundSyncFromMain);
        document.removeEventListener('click', this.boundOverlayCheck);
        document.removeEventListener('keydown', this.boundOverlayCheck);
        document.removeEventListener('bcw:overlay-change', this.boundCheckPosition);
        window.removeEventListener('scroll', this.boundCheckPosition);
        window.removeEventListener('resize', this.boundMediaChange);
        this.overlayObserver?.disconnect();
        if (this.mobileQuery?.removeEventListener) {
          this.mobileQuery.removeEventListener('change', this.boundMediaChange);
        } else {
          this.mobileQuery?.removeListener(this.boundMediaChange);
        }
      }

      getMainButton() {
        return document.querySelector('product-info button[name="add"][type="submit"], product-info .product-form__submit[name="add"], product-info form[action*="/cart/add"] button[type="submit"]');
      }

      getMainQuantity() {
        return document.querySelector('product-info input.quantity__input[name="quantity"], product-info input[name="quantity"]');
      }

      getMainVariantId() {
        const checked = document.querySelector('product-info input[name="id"]:checked');
        const mainForm = this.getMainButton()?.closest('form');
        const field = checked || mainForm?.querySelector('select[name="id"], input[name="id"]');
        return field?.value || this.currentVariantId;
      }

      getMainSellingPlanId() {
        const mainForm = this.getMainButton()?.closest('form');
        return mainForm?.querySelector('input[name="selling_plan"]')?.value || '';
      }

      syncFromMain() {
        window.setTimeout(() => {
          const variantId = String(this.getMainVariantId());
          if (this.variants[variantId]) {
            this.currentVariantId = variantId;
          }
          const mainQuantity = this.getMainQuantity();
          if (mainQuantity) {
            this.quantity = Math.max(1, Number.parseInt(mainQuantity.value, 10) || 1);
            this.quantityInput.value = this.quantity;
          }
          this.renderState();
        }, 0);
      }

      setQuantity(value) {
        this.quantity = Math.max(1, value);
        this.quantityInput.value = this.quantity;
        const mainQuantity = this.getMainQuantity();
        if (mainQuantity) {
          mainQuantity.value = this.quantity;
          mainQuantity.dispatchEvent(new Event('input', { bubbles: true }));
          mainQuantity.dispatchEvent(new Event('change', { bubbles: true }));
        }
        document.dispatchEvent(new CustomEvent('quantity:change', {
          detail: { quantity: this.quantity },
          bubbles: true
        }));
        this.renderState();
      }

      formatMoney(cents) {
        const locale = navigator.languages?.[0]
          || navigator.language
          || document.documentElement.lang
          || 'en-GB';

        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: this.dataset.currency,
          currencyDisplay: 'narrowSymbol'
        }).format(cents / 100);
      }

      renderState() {
        const variant = this.variants[this.currentVariantId];
        if (!variant) return;
        const sellingPlan = variant.sellingPlans?.[this.getMainSellingPlanId()];
        const unitPrice = sellingPlan ? sellingPlan.price : variant.price;
        this.total.textContent = this.formatMoney(unitPrice * this.quantity);
        const available = Boolean(variant.available);
        this.submit.disabled = !available;
        this.submitLabel.textContent = available ? this.dataset.addLabel : this.dataset.unavailableLabel;
      }

      isBlockingOverlayOpen() {
        if (document.body.classList.contains('bcw-blocking-overlay-open')) return true;
        if (document.querySelector('cart-drawer.active, cart-drawer[open]')) {
          return true;
        }
        const selectors = [
          '.country-selector:not([hidden])',
          'details.menu-drawer-container[open]',
          'dialog[open]'
        ];
        return selectors.some((selector) => [...document.querySelectorAll(selector)].some((element) => {
          const style = window.getComputedStyle(element);
          return style.display !== 'none' && style.visibility !== 'hidden';
        }));
      }

      checkPosition() {
        if (!this.mobileQuery.matches) {
          this.setBarVisibility(false);
          return;
        }
        if (this.isBlockingOverlayOpen()) {
          this.setBarVisibility(false);
          return;
        }
        const mainButton = this.getMainButton();
        if (!mainButton) {
          this.setBarVisibility(false);
          return;
        }
        const barHeight = this.bar.offsetHeight || 64;
        const rect = mainButton.getBoundingClientRect();
        const stickyHeader = document.querySelector('.header-group-sticky');
        const stickyHeaderBottom = stickyHeader
          ? Math.max(0, stickyHeader.getBoundingClientRect().bottom)
          : 0;
        const visibleTop = Math.max(rect.top, stickyHeaderBottom, 0);
        const visibleBottom = Math.min(rect.bottom, window.innerHeight - barHeight);
        const visibleHeight = Math.max(0, visibleBottom - visibleTop);
        const visibilityThreshold = Math.min(32, rect.height * 0.65);
        const purchaseIsVisible = visibleHeight >= visibilityThreshold;
        this.setBarVisibility(!purchaseIsVisible);
      }

      setBarVisibility(visible) {
        this.bar.classList.toggle('is-visible', visible);
        this.bar.setAttribute('aria-hidden', String(!visible));
      }

      addToCart() {
        const mainButton = this.getMainButton();
        if (!mainButton || mainButton.disabled || this.submit.disabled) return;
        const mainQuantity = this.getMainQuantity();
        if (mainQuantity) {
          mainQuantity.value = this.quantity;
          mainQuantity.dispatchEvent(new Event('input', { bubbles: true }));
          mainQuantity.dispatchEvent(new Event('change', { bubbles: true }));
        }
        this.submit.classList.add('is-loading');
        this.submit.setAttribute('aria-busy', 'true');
        mainButton.click();
        window.setTimeout(() => {
          this.submit.classList.remove('is-loading');
          this.submit.removeAttribute('aria-busy');
        }, 900);
      }

    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
